import 'select2/dist/js/select2.full.js'
// import 'select2/dist/js/i18n/fr.js'

jQuery('.nav-dropdown select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.gform_wrapper select').select2({
    width: '100%'
})

jQuery('.children_nav_mobile select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown-mobile select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.dining-dropdown select').select2({
    width: '100%',
})

jQuery('.practice__days__select select').select2({
    width: '100%',
})

jQuery('.guide-me__filter select').select2({
    width: '100%',
})

jQuery('.map-view-seat select').select2({
    width: '100%',
})

jQuery('.children_nav_mobile select').select2({
    width: '100%'
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.third_nav_dropdown select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.pfts select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})